import { supabase } from './supabase';
import { useAuth } from './session';
import Metadata from './Metadata';

// The Console shell: identity, sign-out, and the tabbed body. Books, tags and contributors all
// live in the tablist rather than stacking down the page — the Book list is the work surface and
// belongs beside the reference data, not above it.
export default function Home() {
  const auth = useAuth();
  const email = auth.status === 'admin' ? auth.session.user.email : null;

  return (
    <main>
      <header className="bar">
        <h1>Admin Console</h1>
        <div>
          <span className="muted">{email}</span>
          <button onClick={() => supabase.auth.signOut()}>Sign out</button>
        </div>
      </header>
      <Metadata />
    </main>
  );
}
